
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import useBidStore from '../../store/bidStore';
// import { addBid, fetchCategory, getSingleBid, getSingleBidDetails1, updateBid } from '../../api/SurveyorRequest';
import { Form, Input, Select, Radio, DatePicker, Checkbox, Button, notification, Spin, message } from "antd";
import ErrorLogout from '../../../helpers/ErrorLogout';
import ImageVideoUploader from '../../../helpers/imageVideoUploader/ImageVideoUploader';
import CategoryImageUploader from '../../../helpers/imageVideoUploader/CategoryImageUploader';
import moment from 'moment';
import { addBid, getSingleBidDetails1, updateBid, createBid } from '../../../api/AdminRequest';
import { getAllCategory } from '../../../api/AdminRequest';
import useAuthStore from '../../../store/authStore';

import PropTypes from "prop-types";
import GoogleMapLocationPicker from '../../googlemap/GoogleMapLocationPicker';
import DocumentUploader from '../../../helpers/imageVideoUploader/DocumentUploader';

const { TextArea } = Input;

function CreateBidForm({ edit }) {

  const navigate = useNavigate();
  const { state } = useLocation();
  const { isAuthenticated, userRefToken } = useAuthStore();

  const tabItems = [
    { key: "Basic Info", label: "Basic Info" },
    { key: "Detailed Info", label: "Detailed Info" },
  ];

  const initail = {

    "Full Front View": [],
    "Odometer Reading": [],
    "Front Left Angle": [],
    "Front Right Angle": [],
    "Rear View": []

  }

  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("Basic Info");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [formFields, setFormFields] = useState([]);
  const [basicInfoData, setBasicInfoData] = useState({});
  const [images, setImages] = useState([]);
  const [thumbnail, setThumbnail] = useState(0)
  // const [images, setImages] = useState(bidData?.productImage ? bidData?.productImage : []);
  // const [thumbnail, setThumbnail] = useState(bidData?.thambnail ? bidData?.thambnail : 0)
  // const [galleryImages, setGalleryImages] = useState(bidData?.galleryImages ? bidData?.galleryImages : initail);
  const [galleryImages, setGalleryImages] = useState({});
  const [imageError, setImageError] = useState('');
  const [bidID, setBidID] = useState();
  const [bidDetails, setBidDetails] = useState();

  const [documents, setDocuments] = useState([]);
  const [location, setLocation] = useState();
  const [locationError, setLocationError] = useState('');

  const [form] = Form.useForm();
  // console.log(imageError, 'imageError');


  useEffect(() => {
    const getCategory = async () => {
      try {
        setLoader(true);
        const { data } = await getAllCategory();
        if (data?.success && data?.categoryData?.length) {
          setCategories(data.categoryData);
        } else {
          console.error("No category data found or data format incorrect:", data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoader(false);
      }
    };
    getCategory();
  }, []);


  useEffect(() => {
    // Fetch initial form data if editing
    const loadInitialData = async () => {
      if (edit && state?.bidId) {
        try {
          const { data } = await getSingleBidDetails1(state.bidId);
          // console.log(data);

          if (data.success) {
            const bidInfo = data.singleBid;
            setBidDetails(bidInfo);
            setThumbnail(bidInfo?.thumbnail)

            // Setting initial data in form
            form.setFieldsValue({
              productName: bidInfo.productName,
              category: bidInfo.category,
              subCategory: bidInfo.subCategory,
              expectedPrice: bidInfo.expectedPrice,
              ...bidInfo.detailedInfo,
              registrationYear: moment(bidInfo.detailedInfo.registrationYear), // Date field
              builtYear: moment(bidInfo.detailedInfo.builtYear), // Date field
            });



            setImages(bidInfo.productImage || []);
            setGalleryImages(bidInfo.galleryImages || []);

            setLocation(bidInfo.location || []);

            const documentsArray = bidInfo.documents ? Object.values(bidInfo.documents) : []
            setDocuments(documentsArray.length > 0 ? documentsArray[0] : []);

          } else {
            console.error("Failed to fetch bid details:", data);
          }
        } catch (error) {
          console.error("Error fetching bid details:", error);
        }
      }
    };
    loadInitialData();
  }, [edit, state?.bidId, categories]);

  // console.log(categories, 'outsise cat');
  // console.log(subCategories, 'outsise subbbbb');


  useEffect(() => {
    // Ensure subcategories are set correctly based on selected category
    if (categories.length > 0 && bidDetails && edit) {
      // console.log(categories, 'indside iff');
      const selectedCategory = categories.find((cat) => cat._id === bidDetails.category);
      // console.log(selectedCategory, 'indside iff selectedCategory');
      if (selectedCategory) {
        setSubCategories(selectedCategory.subCategories || []);
      }
    }
  }, [categories, bidDetails]);


  useEffect(() => {
    // Ensure form fields are set based on subcategory
    if (subCategories.length > 0 && bidDetails && edit) {
      const selectedSubCategory = subCategories.find((sub) => sub._id === bidDetails.subCategory);
      // console.log(selectedSubCategory, 'selectedSubCategory in effect');

      if (selectedSubCategory) {
        setFormFields(selectedSubCategory.form || []);
        // console.log(bidDetails.galleryImages);

        setGalleryImages(Object.keys(bidDetails.galleryImages).length !== 0 ? bidDetails.galleryImages : selectedSubCategory.galleryInitial || {});
      }
    }
  }, [subCategories, bidDetails]);


  const handleCategoryChange = (value) => {
    // console.log(value, 'value cat');

    const selectedCategory = categories.find((cat) => cat._id === value);
    setSubCategories(selectedCategory ? selectedCategory.subCategories : []);
    form.setFieldsValue({ subCategory: null }); // Reset subcategory when category changes
    setFormFields([]);
  };

  const handleSubCategoryChange = (value) => {
    const selectedSubCategory = subCategories.find((sub) => sub._id === value);
    // console.log(selectedSubCategory, 'selectedSubCategory');

    setFormFields(selectedSubCategory ? selectedSubCategory.form : []);
    setGalleryImages(selectedSubCategory.galleryInitial || {});

  };

  const validateAndNext = async () => {
    try {
      const values = await form.validateFields(["productName", "category", "subCategory", "expectedPrice"]);
      // setBasicInfoData(values); // Save "Basic Info" data to state
      setBasicInfoData({ ...values, thumbnail });

      if (!location?.lat && !location.lng) {
        setLocationError("select the location")
        throw new Error("location is required.");
      } else {
        setLocationError("")
      }

      if (images?.length === 0 || !images || images.every(obj => obj.status === "removed")) {
        // let newErrors
        // newErrors.images = "At least one image is required.";
        // valid = false;

        setImageError("At least one image is required.")
        throw new Error("At least one image is required.");
        // message.error("At least one image is required.");
        // addBidData("error", newErrors);

      } else {
        setImageError("")

        setActiveTab("Detailed Info");
      }


    } catch (error) {
      notification.error({ message: "Please complete required fields in Basic Info", description: error.message });
    }
  };

  const onFinish = async (val) => {
    const values = { ...basicInfoData, ...val }; // Merge Basic Info and Detailed Info data
    // console.log("Form submitted with values final:", values);
    // addBidData(finalData);

    setLoader(true);
    values.images = images
    values.gallery = galleryImages
    values.location = location
    values.documents = documents


    const datas = new FormData();

    let imagesArray = []
    values?.images?.forEach((item, index) => {
      // removing thd removed images 
      if (item?.status !== 'removed') {
        imagesArray.push(item)
      }
    });
    imagesArray.forEach((item, index) => {
      // If originFileObj exists and it's not empty
      if (item?.originFileObj && item?.originFileObj?.type && item?.status === 'done') {
        // console.log(item.originFileObj, 'item.originFileObj');
        datas.append(`images`, item.originFileObj, `images-${index}`);
      }
    });

    {
      Object.keys(values.gallery).map((key) => {

        let imagesArray = []
        values?.gallery[key]?.forEach((item, index) => {
          // removing thd removed images 
          if (item?.status !== 'removed') {
            imagesArray.push(item)
          }
        });
        imagesArray.forEach((item, index) => {
          // If originFileObj exists and it's not empty
          if (item?.originFileObj && item?.originFileObj?.type && item?.status === 'done') {
            // console.log(item.originFileObj, 'item.originFileObj');
            datas.append('galleryImages', item.originFileObj, `${key}-${index}`);
          }
        });
      })
    }

    //document

    let documentArray = []
    values?.documents?.forEach((item, index) => {
      // removing thd removed images 
      if (item?.status !== 'removed') {
        documentArray.push(item)
      }
    });
    documentArray.forEach((item, index) => {
      // If originFileObj exists and it's not empty
      if (item?.uid && item?.type && item?.status === 'done') {
        // console.log(item.originFileObj, 'item.originFileObj');
        datas.append(`documents`, item, `document-${index}`);
      }
    });

    // Append the rest of the values to FormData
    Object.keys(values).forEach((key) => {
      datas.append(key, values[key]);
    });

    datas.append('detailedInfoDetails', JSON.stringify(val))
    datas.append('imageDetails', JSON.stringify(values.images))
    datas.append('galleryDetails', JSON.stringify(values.gallery))
    datas.append('locationDetails', JSON.stringify(values.location))
    datas.append('documentDetails', JSON.stringify(values.documents))

    const details = {
      detailedInfoID: bidDetails?.detailedInfoID,
      surveyID: bidDetails?.surveyID
    }
    datas.append('details', JSON.stringify(details))
    // console.log(datas, 'datas');

    try {
      const { data } = edit ? await updateBid(bidDetails._id, datas) : await createBid(datas); // Make the API call
      if (data.success) {
        await message.success("New Bid Added Successfully")
        navigate("/bid-list");
      } else if (data.resubmit) {
        await message.success("Bid resubmit Successfully")
        navigate("/bid-list");
      }
    } catch (error) {
      console.log(error);
      console.log(error.message);
      message.error(error.message)

      if (error?.response?.status === 401) {
        ErrorLogout(error);
        console.log("Unauthorized access");
      }
    } finally {
      setLoader(false); // Stop loading state
    }
  };

  const handleDiscard = () => {
    // clearBidData();
    navigate("/listings");
  };

  const handleTabs = (key) => {
    if (key === 'Detailed Info') {
      validateAndNext()
    } else {
      setActiveTab('Basic Info')
    }
  };


  return (
    <div className="min-h-screen bg-slate-50 px-3 sm:px-6 py-6">
      <div className="w-full max-w-6xl">
        {/* Header - left-aligned */}
        <div className="mb-6 text-left">
          <h1 className="text-2xl font-semibold text-gray-900">Auction Request</h1>
          <p className="text-sm text-gray-500 mt-1">
            Create or edit a listing with product details, location, and media.
          </p>
        </div>

        <Spin spinning={loader}>

          {/* Tabs */}
          <div className="flex bg-white p-1.5 rounded-xl shadow-sm w-fit mb-6 border">
            {tabItems.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => handleTabs(tab.key)}
                className={`px-6 py-2 rounded-lg text-sm font-medium transition ${activeTab === tab.key
                    ? "bg-blue-600 text-white shadow"
                    : "text-gray-500 hover:bg-gray-100"
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <Form layout="vertical" form={form} onFinish={onFinish}>

            {/* ================= BASIC INFO ================= */}
            {activeTab === "Basic Info" && (
              <div className="bg-white p-6 rounded-xl shadow border text-left">
                {/* Product Info */}
                <h3 className="text-lg font-semibold text-gray-900 mb-4 text-left">Product Info</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Form.Item label="Product Name" name="productName" rules={[{ required: true }]}>
                    <Input className="h-10" placeholder="Product name" />
                  </Form.Item>

                  <Form.Item label="Expected Price" name="expectedPrice" rules={[{ required: true }]}>
                    <Input type="number" className="h-10" placeholder="₹ Expected price" />
                  </Form.Item>

                  <Form.Item label="Category" name="category" rules={[{ required: true }]}>
                    <Select
                      disabled={edit}
                      onChange={handleCategoryChange}
                      options={categories.map((c) => ({ label: c.name, value: c._id }))}
                    />
                  </Form.Item>

                  <Form.Item label="Sub Category" name="subCategory" rules={[{ required: true }]}>
                    <Select
                      disabled={edit}
                      onChange={handleSubCategoryChange}
                      options={subCategories.map((s) => ({ label: s.name, value: s._id }))}
                    />
                  </Form.Item>
                </div>

                <div className="my-6 border-t border-gray-200" />

                {/* Images (dropzone UI only, same logic) */}
                <ImageVideoUploader
                  images={images}
                  setImages={setImages}
                  productID={bidID}
                  identifier="image"
                  thumbnail={thumbnail}
                  setThumbnail={setThumbnail}
                  variant="createBid"
                />
                {imageError && <p className="text-red-500 mt-2">{imageError}</p>}

                <div className="my-6 border-t border-gray-200" />

                {/* Location */}
                <h3 className="text-lg font-semibold text-gray-900 mb-4 text-left">Location</h3>

                <div className="w-full">
                  <GoogleMapLocationPicker location={location} setLocation={setLocation} />

                  {/* Coordinate text just below the selector (same format as old box) */}
                  {location?.lat && location?.lng && (
                    <div className="mt-2 text-sm text-gray-600 space-y-1">
                      <p>
                        Lat:&nbsp;
                        <span className="font-mono">{location.lat}</span>
                      </p>
                      <p>
                        Lng:&nbsp;
                        <span className="font-mono">{location.lng}</span>
                      </p>
                    </div>
                  )}
                </div>

                {locationError && <p className="text-red-500 mt-2">{locationError}</p>}

                <div className="mt-6 flex justify-end gap-3">
                  <Button onClick={handleDiscard}>Cancel</Button>
                  <Button type="primary" onClick={validateAndNext}>
                    Continue
                  </Button>
                </div>
              </div>
            )}

            {/* ================= DETAILED INFO ================= */}
            {activeTab === "Detailed Info" && (
              <div className="space-y-6">

                {/* Dynamic fields */}
                <div className="bg-white p-6 rounded-xl shadow border">
                  <h3 className="font-semibold mb-4">Detailed Info</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {formFields.map((field, i) => (
                      <Form.Item key={i} label={field.label} name={field.name} rules={[{ required: field.required }]}>
                        {field.type === "text" && <Input />}
                        {field.type === "number" && <Input type="number" />}
                        {field.type === "textarea" && <TextArea rows={3} />}
                        {field.type === "select" && <Select options={field.values} />}
                        {field.type === "date" && <DatePicker className="w-full" />}
                      </Form.Item>
                    ))}
                  </div>
                </div>

                {/* Documents */}
                <div className="bg-white p-6 rounded-xl shadow border">
                  <h3 className="font-semibold mb-4">Documents</h3>
                  <DocumentUploader documents={documents} setDocuments={setDocuments} />
                </div>

                {/* Gallery */}
                <div className="bg-white p-6 rounded-xl shadow border">
                  <h3 className="font-semibold mb-4">Gallery</h3>
                  <CategoryImageUploader images={galleryImages} setImages={setGalleryImages} bidID={bidDetails?._id} edit={edit} />
                </div>

                {/* Submit */}
                <div className="flex justify-end gap-3">
                  <Button onClick={() => setActiveTab("Basic Info")}>Back</Button>
                  <Button type="primary" htmlType="submit" loading={loader}>
                    Submit Listing
                  </Button>
                </div>
              </div>
            )}

          </Form>
        </Spin>
      </div>
    </div>
  );
}


CreateBidForm.propTypes = {
  edit: PropTypes.object,
};
export default CreateBidForm;

